

// // export default TopBar;
// import React, { useEffect, useState } from 'react';
// import { BASE_URL } from '../../api/apiClient';

// const TopBar = () => {
//   const [topbar, setTopbar] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     (async () => {
//       try {
//         const res = await fetch(`${BASE_URL}/api/femcare/`);
//         const json = await res.json().catch(() => ({}));
//         if (!res.ok) throw new Error(json?.error || `Request failed (${res.status})`);
//         setTopbar(json?.topbar ?? null);
//       } catch (e) {
//         setError(e.message);
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);

//   // Don't render anything while loading, on error, or if the section
//   // failed to load — same convention as Footer/Hero.
//   if (loading || error || !topbar) return null;

//   return (
//     <div className="primary-bg w-full">
//       <div className=" px-4 md:px-8">
//         <div className="flex items-center justify-between h-10">

//           {/* Left: Call + Office Hours */}
//           <div className="flex items-center gap-1 text-white ava-text-sm font-light">
//             <img
//               src="/Home/phone.svg"
//               alt="Phone"
//               className="w-3.5 h-3.5 mr-1 flex-shrink-0"
//             />
//             <span>
//               {topbar.contact?.label} : {topbar.contact?.phone}
//             </span>
//             <span className="mx-2 opacity-60">-</span>
//             <span className="hidden sm:inline">{topbar.contact?.officeHours}</span>
//           </div>

//           {/* Right: Experience App on Mobile */}
//           <div className="flex items-center gap-2 text-white ava-text-sm font-light">
//             <span className="hidden sm:inline">{topbar.appBanner?.label}</span>
//             <span className="sm:hidden">Get the App</span>

//             {/* Play Store */}
//             <a
//               href={topbar.appBanner?.playStoreLink}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="flex items-center hover:opacity-80 transition-opacity"
//               aria-label="Download on Google Play"
//             >
//               <img src="/Home/playstore.svg" alt="Google Play" className="h-5 w-5" />
//             </a>

//             {/* Apple Store */}
//             <a
//               href={topbar.appBanner?.appStoreLink}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="flex items-center hover:opacity-80 transition-opacity"
//               aria-label="Download on App Store"
//             >
//               <img src="/Home/applestore.svg" alt="App Store" className="h-5 w-5" />
//             </a>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default TopBar;
import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../api/apiClient';

const ITEM_ICONS = {
  call: '/Home/phone.svg',
  phone: '/Home/phone.svg',
  email: '/Home/mail.svg',
  location: '/Home/location.svg',
};

const SOCIAL_ICONS = {
  facebook: '/Home/facebook.svg',
  instagram: '/Home/instagram.svg',
  youtube: '/Home/youtube.svg',
  twitter: '/Home/twitter.svg',
  linkedin: '/Home/linkedin.svg',
  location: '/Home/location.svg',
};

const isActive = (i) => i.status !== 0;
const byOrder = (arr) => [...arr].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

// If an item has a label, look up its icon by that label ("Call" → phone.svg).
// If it's blank (icon-only items), fall back to guessing from the value shape
// (contains "@" → email, starts with a digit → phone, else → location).
// If an item has a label, only show an icon when that exact label is in
// the map ("Call", "Phone", "Email", "Location"). Anything else with a
// label — like "Office hours" — renders with no icon, no guessing.
// Only truly unlabeled items (icon-only bars like the pink one) fall back
// to guessing an icon from the shape of the value.
function iconFor(item, map) {
  const key = (item.label || '').trim().toLowerCase();
  if (key) {
    return map[key]; // undefined if not found — correctly renders no icon
  }
  const v = item.value || '';
  if (v.includes('@')) return map.email;
  if (/^[+\d]/.test(v)) return map.phone;
  return map.location;
}

const TopBar = () => {
  const [topbar, setTopbar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/femcare/`);
        const json = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(json?.error || `Request failed (${res.status})`);
        setTopbar(json?.topbar ?? null);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading || error || !topbar) return null;

  const items = byOrder(topbar.items || []).filter(isActive);
  const rightSlot = topbar.rightSlot;
  const mode = rightSlot?.mode ?? 'appBanner';
  const socialLinks = byOrder(rightSlot?.socialLinks || []).filter(isActive);

  return (
    <div className="primary-bg w-full">
      <div className="px-4 md:px-8">
        <div className="flex items-center justify-between h-10">

          {/* Left: items — renders "Label : value" if label is set, else just the icon + value */}
          <div className="flex items-center gap-1 text-white ava-text-sm  flex-wrap">
            {items.map((item, idx) => {
              const icon = iconFor(item, ITEM_ICONS);
              return (
                <React.Fragment key={item.id}>
                  {idx > 0 && <span className="mx-2 opacity-60">-</span>}
                  <span className="flex items-center gap-1">
                    {icon &&  <img src={icon} alt={item.label || 'icon'} className="w-3.5 h-3.5 flex-shrink-0" />}
                    <span className={idx === 0 ? '' : 'hidden sm:inline'}>
                      {item.label ? `${item.label} : ${item.value}` : item.value}
                    </span>
                  </span>
                </React.Fragment>
              );
            })}
          </div>

          {/* Right: app banner or social/utility icons */}
          <div className="flex items-center gap-2 text-white ava-text-sm ">
            {mode === 'appBanner' ? (
              <>
                <span className="hidden sm:inline">{rightSlot?.appBanner?.label}</span>
                <span className="sm:hidden">Get the App</span>
                
               <a   href={rightSlot?.appBanner?.playStoreLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center hover:opacity-80 transition-opacity"
                  aria-label="Download on Google Play"
                >
                  <img src="/Home/playstore.svg" alt="Google Play" className="h-5 w-5" />
                </a>
                
               <a href={rightSlot?.appBanner?.appStoreLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center hover:opacity-80 transition-opacity"
                  aria-label="Download on App Store"
                >
                  <img src="/Home/applestore.svg" alt="App Store" className="h-5 w-5" />
                </a>
              </>
            ) : (
              socialLinks.map((link) => {
                const icon = iconFor(link, SOCIAL_ICONS);
                return (
                  
               <a key={link.id}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center hover:opacity-80 transition-opacity"
                    aria-label={link.label}
                  >
                    {icon ? <img src={icon} alt={link.label} className="h-5 w-5" /> : <span className="text-xs">{link.label}</span>}
                  </a>
                );
              })
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default TopBar;